import { render, staticRenderFns } from "./EventSignup.vue?vue&type=template&id=1c897527&scoped=true&"
import script from "./EventSignup.vue?vue&type=script&lang=js&"
export * from "./EventSignup.vue?vue&type=script&lang=js&"
import style0 from "./EventSignup.vue?vue&type=style&index=0&id=1c897527&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c897527",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTextField,VTextarea})
